import React from "react";

export const About = () => (
  <div className="jumbotron">
    <div className="container">
      <h1 className="display-4">Лучшее React приложение</h1>
      <p className="lead">
        Версия приложения: <strong>1.0.42</strong>
      </p>
    </div>
  </div>
);
